<template>
  <div v-if="attaches && attaches.length > 0" class="container">
    <template v-for="(attach, index) in attaches" :key="index">
      <div
          v-if="attach && attach.attachUrl"
          class="image-wrapper"
          :class="{ 'single-image': attaches.length === 1 }"
          :style="imageWrapperStyle"
      >
        <img
            :src="attach.attachUrl"
            :alt="`Image ${index + 1}`"
            class="image"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts" name="QuestionImage">
import { computed, ref } from 'vue'

interface AttachType {
  attachUrl?: string
}

interface Props {
  attaches?: AttachType[]
}

const props = defineProps<Props>()

// Mobil simülatör genişliği - padding'ler çıkarılmış
// Phone content width (300px) - horizontal padding (20px * 2) = 260px
const screenWidth = ref(260)

const getGridLayout = (imageCount: number): number => {
  if (imageCount === 1) return 1
  if (imageCount === 2) return 2
  return 3
}

const columns = computed(() => {
  if (!props.attaches) return 1
  return getGridLayout(props.attaches.length)
})

const imageSize = computed(() => {
  // Tek resim için container genişliğini kullan
  if (props.attaches?.length === 1) {
    return screenWidth.value
  }

  // React Native'deki tam hesaplama
  // columns = 2 için: (260 - 30) / 2 = 115px
  // columns = 3 için: (260 - 40) / 3 = 73.33px
  return (screenWidth.value - (columns.value + 1) * 10) / columns.value
})

const imageWrapperStyle = computed(() => {
  if (props.attaches?.length === 1) {
    return {
      width: '100%',
      height: imageSize,
      maxHeight: '220px'
    }
  }

  return {
    width: `${imageSize.value}px`,
    height: `${imageSize.value}px`,
    maxHeight: '220px'
  }
})


</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.image-wrapper {
  border-radius: 9px;
  overflow: hidden;
  background-color: #f5f5f5;
}

.image-wrapper.single-image {
  width: 100%;
  background-color: transparent;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 9px;
}

.single-image .image {
  height: auto;
  max-height: 220px;
  object-fit: cover;
}
</style>